import { render, staticRenderFns } from "./SpellcheckerAcceptDismissButtons.vue?vue&type=template&id=445e0cad&scoped=true&"
import script from "./SpellcheckerAcceptDismissButtons.vue?vue&type=script&lang=js&"
export * from "./SpellcheckerAcceptDismissButtons.vue?vue&type=script&lang=js&"
import style0 from "./SpellcheckerAcceptDismissButtons.vue?vue&type=style&index=0&id=445e0cad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e0cad",
  null
  
)

export default component.exports